<template>
  <ny-main title="Infinities 代理商平台" platform="agency" :route-data="routeData"></ny-main>
</template>

<script>
import NyMain from '@/global/views/Main'
import { routeData } from '../router'

export default {
  name: 'Main',
  components: {
    NyMain
  },
  data () {
    return {
      routeData
    }
  }
}
</script>
